import { useState, useCallback } from "react";
import { useAuth } from "../../../components/context/LoginContext/AuthContext";

/**
 * @typedef {Object} ApprovePaymentResponse
 * @property {boolean} success
 * @property {string} admin_remarks
 * @property {any} data
 */

/**
 * Hook to approve a payment
 */
export const useApprovePayment = () => {
  const { fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Approve a payment
   * @param {number|string} paymentId
   * @returns {Promise<ApprovePaymentResponse>}
   */
  const approvePayment = useCallback(
    async (paymentId) => {
      if (!paymentId) throw new Error("Payment ID is required");

      setLoading(true);
      setError(null);

      try {
        const response = await fetchWithAuth(
          `${apiUrl}/school/payments/${paymentId}/verify`,
          { method: "POST" }
        );

        if (!response.ok) {
          throw new Error("Failed to approve payment");
        }

        const result = await response.json();

        if (!result.success) {
          throw new Error(result.message || "Failed to approve payment");
        }

        return result;
      } catch (err) {
        console.error("Approve Payment Error:", err);
        setError(err.message || "Something went wrong");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [apiUrl, fetchWithAuth]
  );

  return {
    approvePayment,
    loading,
    error,
  };
};
